import Vue from 'vue'
import uris from '../utils/uris'
import axios from '../utils/axiosWrapper'
import eventBus from '@/utils/eventBus'

import supervisorStorage from './supervisorStorage'

import {map, reduce, omit, find, filter, assign, isEmpty} from 'lodash'

let cards = []
let requestFinished = false

let colors = {
  DEFAULT: {
    status: 'DEFAULT',
    iconPath: 'assets/dashboard-icons/indicator-gray.png',
    color: 'grey',
    dangerValue: -1
  },
  LIGHT_GREY: {
    status: 'LIGHT_GREY',
    iconPath: 'assets/dashboard-icons/indicator-gray.png',
    color: 'grey lighten-2',
    dangerValue: -1
  },
  LIGHT_GREEN: {
    status: 'LIGHT_GREEN',
    iconPath: 'assets/dashboard-icons/indicator-gray.png',
    color: 'green lighten-2',
    dangerValue: -1
  },
  LIGHT_RED: {
    status: 'LIGHT_RED',
    iconPath: 'assets/dashboard-icons/indicator-light-red.png',
    color: 'red lighten-2',
    dangerValue: 0
  },
  GREEN: {
    status: 'GREEN',
    iconPath: 'assets/dashboard-icons/indicator-green.png',
    color: 'green',
    dangerValue: -1
  },
  AMBER: {
    status: 'AMBER',
    iconPath: 'assets/dashboard-icons/indicator-amber.png',
    color: 'amber',
    dangerValue: 1
  },
  RED: {
    status: 'RED',
    iconPath: 'assets/dashboard-icons/indicator-red.png',
    color: 'red',
    dangerValue: 5
  }
}

/**
 * @typedef {Object} LogDetail
 * @prop {Boolean} visible Will be visible to in the log section of each distributor's detail
 * @prop {Boolean} highlightable Higlight attribute for Vue components that change when toggling showAll
 * @prop {String} label Determinates label for data
 * @prop {function(Boolean):String|import("vue").VueConstructor} data Will show data from the distributor as a String or as a Vue Component for more complexity
 */
function cardsComplementary () {
  return [
    {
      cardType: 'DEFAULT',
      enabled: true,
      iconPath: 'assets/dashboard-icons/card-remote-files.png',
      info: () => { // It's a function since the returned value can be a calculated one
        return {
          lightColor: 'grey',
          cardNumber: 0,
          message: 'No se ha encontrado los datos de la tarjeta'
        }
      },
      details: {
        title: 'Título de definido',
        message: 'Mensaje no definido',
        body: {
          card: [],
          detail: []
        }
      },
      indicator: () => { // Same as the info key
        let baseColor = colors.LIGHT_GREY
        return baseColor
      },
      fab: {
        list: [
          {
            color: colors.LIGHT_GREY,
            status: 'Indefinido'
          }
        ],
        active: false,
        selectedIndex: 0
      },
      logDetails: () => {
        return [
          {
            visible: true,
            highlightable: false,
            label: 'No definido',
            data: (showAll) => 'No definido'
          }
        ]
      }
    },
    {
      cardType: 'VALIDATOR',
      enabled: true,
      iconPath: 'assets/dashboard-icons/card-remote-files.png',
      info: (isLoading) => {
        return {
          lightColor: colors.RED,
          cardNumber: '99+',
          message: 'No definido'
        }
      },
      details: {
        title: 'Título no definido',
        message: 'Mensaje no definido',
        body: {
          card: [
            {
              color: '',
              description: 'No definido'
            }
          ],
          detail: [
            {
              color: '',
              description: 'No definido'
            }
          ]
        }
      },
      indicator: (item) => {
        let baseColor = colors.LIGHT_GREY
        return baseColor
      },
      fab: {
        list: [
          {
            color: colors.LIGHT_GREY,
            status: 'Indefinido'
          }
        ],
        active: false,
        selectedIndex: 0
      },
      logDetails: (distributor) => {
        return [
          {
            visible: true,
            highlightable: false,
            label: 'No definido',
            data: (showAll) => 'No definido'
          }
        ]
      }
    },
    {
      cardType: 'REMOTE FILES',
      enabled: true,
      iconPath: 'assets/dashboard-icons/card-remote-files.png',
      info: (isLoading) => {
        const outdated = supervisorStorage.getOutDatedFtpFiles()
        const updated = supervisorStorage.getUpdatedFtpFiles()
        const total = updated + outdated

        const percentageUpdated = updated / total
        if (isLoading) {
          return {
            lightColor: 'gray',
            cardNumber: outdated,
            message: 'Verificando archivos'
          }
        }
        if (total === updated) { // to avoid undefined trap, do not use percetageUpdated === 1
          return {
            lightColor: colors.GREEN,
            cardNumber: 0,
            message: 'Todas las distribuidora(s) enviaron sus archivos'
          }
        }
        if (percentageUpdated > 0.9) {
          return {
            lightColor: colors.AMBER,
            cardNumber: outdated,
            message: `de ${total} distribuidora(s) no ha enviado sus archivos`
          }
        }
        return {
          lightColor: colors.RED,
          cardNumber: outdated,
          message: `de ${total} distribuidora(s) no ha enviado sus archivos`
        }
      },
      details: {
        title: `Título para 'Archivos FTP'`,
        message: ``,
        body: {
          card: [
            {
              color: colors.GREEN,
              description: 'El 100% de distribuidoras envió sus archivos a la fecha'
            },
            {
              color: colors.AMBER,
              description: 'Al menos 90% de distribuidoras envió sus achivos a la fecha'
            },
            {
              color: colors.RED,
              description: 'Menos del 90% de distribuidoras envió sus archivos a la fecha'
            }
          ],
          detail: [
            {
              color: colors.GREEN,
              description: 'Archivos no están fuera de fecha'
            },
            {
              color: colors.AMBER,
              description: 'Archivos tienen hasta 2 días de antiguedad'
            },
            {
              color: colors.RED,
              description: 'Archivos tienen más de 2 días de antiguiedad'
            },
            {
              color: colors.LIGHT_RED,
              description: 'No se encontraron archivos'
            }
          ]
        }
      },
      indicator: (item) => {
        let baseColor = colors.LIGHT_RED

        return item.found ? (!item.isOutdated || item.fromNow === 'a day ago' ? colors.GREEN : (item.fromNow === '2 days ago' ? colors.AMBER : colors.RED)) : baseColor
      },
      fab: {
        list: [
          {
            color: colors.LIGHT_RED,
            status: 'Incompleto, no encontrado'
          },
          {
            color: colors.RED,
            status: 'Errores graves'
          },
          {
            color: colors.AMBER,
            status: 'Pocos errores'
          },
          {
            color: colors.GREEN,
            status: 'Correcto'
          }
        ],
        active: false,
        selectedIndex: 0
      },
      /**  @returns {Array<LogDetail>}  */
      logDetails: (distributor) => {
        return [
          {
            visible: false,
            highlightable: false,
            label: 'Última fecha de modificación',
            data: (showAll) => `${distributor.modifyTime || 'No se encontró'} (${distributor.fromNow || 'No se encontró'})`
          },
          {
            visible: true,
            highlightable: false,
            label: 'Últimos datos traídos',
            data: (showAll) => `${distributor.fromNow || 'No se encontró'}`
          },
          {
            visible: true,
            highlightable: false,
            label: 'Tamaño de zip',
            data: (showAll) => `${distributor.size || 'No se encontró'}`
          }
        ]
      }
    },
    {
      cardType: 'CONSISTENCIES',
      enabled: true,
      iconPath: 'assets/dashboard-icons/card-consistency.png',
      info: (isLoading) => {
        const consistent = supervisorStorage.getConsistencyCorrectLogs()
        const total = supervisorStorage.getSupervisorFtpFiles().length
        const inconsistent = total - consistent

        const percentageConsistency = consistent / total
        if (isLoading) {
          return {
            lightColor: 'gray',
            cardNumber: 0,
            message: 'Verificando archivos'
          }
        }
        if (total === consistent) {
          return {
            lightColor: colors.GREEN,
            cardNumber: 0,
            message: 'Correcto, todos los archivos tienen formato correcto'
          }
        }
        if (percentageConsistency > 0.9) {
          return {
            lightColor: colors.AMBER,
            cardNumber: inconsistent,
            message: `de ${total} distribuidora(s) tiene archivos con problemas`
          }
        }
        return {
          lightColor: colors.RED,
          cardNumber: inconsistent,
          message: `de ${total} distribuidora(s) tiene archivos con problemas`
        }
      },
      details: {
        title: 'Título no definido',
        message: ``,
        body: {
          card: [
            {
              color: colors.GREEN,
              description: 'El 100% de distribuidoras tiene archivos con el formato correcto'
            },
            {
              color: colors.AMBER,
              description: 'Al menos 90% de distribuidoras tiene archivos con el formato correcto'
            },
            {
              color: colors.RED,
              description: 'Menos del 90% de distribuidoras tiene archivos con el formato correcto'
            }
          ],
          detail: [
            {
              color: colors.GREEN,
              description: 'Logs no contienen errores ni filas removidas'
            },
            {
              color: colors.AMBER,
              description: 'Como máximo, el 10% de logs tiene errores pero no filas removidas'
            },
            {
              color: colors.RED,
              description: 'Más del 10% de logs tiene errores o filas removidas, o está fuera de fecha'
            },
            {
              color: colors.LIGHT_RED,
              description: 'No se encontraron logs o no se los puede leer'
            }
          ]
        }
      },
      indicator: (item) => {
        let baseColor = colors.LIGHT_RED
        // let baseColor = colorIndicators.RED

        return (
          (item.lastLog.length > 0 && item.canReadJsonLog) ? (item.isLastLogOutdated ? colors.RED : (
            reduce(item.lastLog, (total, min) => {
              if (min.fileName) { // Si encuentra ese campo
                return total && (
                  (min.totalLinesInput - min.totalLinesOutput > 0) ||
                  ((
                    min.linesNotMatchingColumns.length +
                    min.linesWithColumnsIssues.length +
                    min.linesWithNotMatchingType.length
                  ) / min.totalLinesInput > 0.1)
                )
              } else if (min.error) {
                return min.error.match(/^File \w+?\.txt not found in file config\.mdlz\.json\.$/)
              } else {
                return false
              }
            }, true) === true ? colors.RED : (
                reduce(item.lastLog, (total, min) => {
                  if (min.fileName) { // Si encuentra ese campo
                    return total && (
                      min.linesNotMatchingColumns.length === 0 &&
                      min.linesWithColumnsIssues.length === 0 &&
                      min.linesWithNotMatchingType.length === 0
                    )
                  } else if (min.error) {
                    return min.error.match(/^File \w+?\.txt not found in file config\.mdlz\.json\.$/)
                  } else {
                    return false
                  }
                }, true) === true ? colors.GREEN : colors.AMBER)
          )) : baseColor
        )
      },
      fab: {
        list: [
          {
            color: colors.LIGHT_RED,
            status: 'Incompleto, no encontrado'
          },
          {
            color: colors.RED,
            status: 'Errores graves'
          },
          {
            color: colors.AMBER,
            status: 'Pocos errores'
          },
          {
            color: colors.GREEN,
            status: 'Correcto'
          }
        ],
        active: false,
        selectedIndex: 0
      },
      /**  @returns {Array<LogDetail>}  */
      logDetails: (distributor) => {
        return [
          {
            visible: false,
            highlightable: false,
            label: 'Última fecha',
            data: (showAll) => `${distributor.lastLogDate || 'No se encontró'} (${distributor.logDateFromNow || 'No se encontró'})`
          },
          {
            visible: true,
            highlightable: false,
            label: 'Problemas con el log',
            data: (showAll) => {
              let failedStatus = !distributor.lastLog.length > 0 || !distributor.canReadJsonLog || distributor.isLastLogOutdated
              let reason = (!distributor.lastLog.length > 0 || !distributor.canReadJsonLog) ? 'No se pudo procesar la información' : (distributor.isLastLogOutdated ? 'Fuera de fecha' : '-')
              return failedStatus ? `Sí. ${reason}` : 'No'
            }
          },
          {
            visible: true,
            highlightable: true,
            label: 'Lista de archivos',
            data: (showAll) => {
              let lastLog = []
              if (distributor.lastLog && !isEmpty(distributor.lastLog)) {
                lastLog = distributor.lastLog
              }
              return (
                Vue.component('log-details', {
                  data () {
                    return {
                      lastLog: lastLog
                    }
                  },
                  template: `
                    <div>
                      <template v-if="!logHasNoProblems(lastLog) || showAll">
                        <div :key="index" v-for="(filedata, index) in lastLog" v-if="!filedata.error && (fileHasProblems(filedata) || showAll)">
                          <div style="font-size:12px;font-weight:500;">Archivo: {{ filedata.fileName }}</div>
                          <ul class="ml-3 mb-1" style="font-size:11px">
                            <li>Filas con columnas disparejas: {{ filedata.linesNotMatchingColumns.length || 'Ninguna' }}</li>
                            <li>Filas con problemas en datos: {{ filedata.linesWithColumnsIssues.length || 'Ninguna' }}</li>
                            <li>Filas con tipos de datos incorrectos: {{ filedata.linesWithNotMatchingType.length || 'Ninguna' }}</li>
                          </ul>
                        </div>
                      </template>
                      <template v-else>
                        No hay archivos con problemas
                      </template>
                    </div>
                  `,
                  methods: {
                    fileHasProblems (filedata) {
                      return filedata.fileName && (filedata.linesNotMatchingColumns.length + filedata.linesWithColumnsIssues.length + filedata.linesWithNotMatchingType.length) > 0
                    },
                    logHasNoProblems (log) {
                      return filter(log, (i) => this.fileHasProblems(i)).length <= 0
                    }
                  },
                  props: {
                    showAll: {
                      type: Boolean,
                      default () {
                        return false
                      }
                    },
                    card: {
                      type: Object,
                      default () {
                        return {}
                      }
                    }
                  }
                })
              )
            }
          }
        ]
      }
    },
    {
      cardType: 'DATABASE',
      enabled: true,
      iconPath: 'assets/dashboard-icons/card-database.png',
      info: (isLoading) => {
        const correct = supervisorStorage.getDatabaseCorrectLogs()
        const total = supervisorStorage.getSupervisorFtpFiles().length
        const incorrect = total - correct

        const percentageCorrect = correct / total
        if (isLoading) {
          return {
            lightColor: 'gray',
            cardNumber: 0,
            message: 'Verificando archivos'
          }
        }
        if (total === correct) {
          return {
            lightColor: colors.GREEN,
            cardNumber: 0,
            message: 'Correcto, ninguna distribuidora tiene datos desactualizados'
          }
        } else if (percentageCorrect > 0.9) {
          return {
            lightColor: colors.AMBER,
            cardNumber: incorrect,
            message: `de ${total} distribuidora(s) tiene datos fuera de fecha`
          }
        } else {
          return {
            lightColor: colors.RED,
            cardNumber: incorrect,
            message: `de ${total} distribuidora(s) tiene datos fuera de fecha`
          }
        }
      },
      details: {
        title: 'Título no definido',
        message: ``,
        body: {
          card: [
            {
              color: colors.GREEN,
              description: 'El 100% de distribuidoras no tiene datos desactualizados'
            },
            {
              color: colors.AMBER,
              description: 'Al menos 90% de distribuidoras no tiene errores en la base de datos'
            },
            {
              color: colors.RED,
              description: 'Menos del 90% de distribuidoras no tiene errores en la base de datos'
            }
          ],
          detail: [
            {
              color: colors.GREEN,
              description: 'Datos de ventas tienen, como máximo, 1 día de antiguedad y están al día'
            },
            {
              color: colors.AMBER,
              description: 'Datos de ventas tienen, como máximo, 2 días de antiguedad'
            },
            {
              color: colors.RED,
              description: 'Datos de ventas tienen más de 2 días de antiguedad'
            }
          ]
        }
      },
      indicator: (item) => {
        return (
          !item.isSalesMaxDateOutdated &&
          !item.isSalesLastUpdatedOutdated
        ) || (item.salesMaxDateFromNow === 'a day ago' || item.salesLastUpdateFromNow === 'a day ago') ? colors.GREEN : ((item.salesMaxDateFromNow === '2 days ago' || item.salesLastUpdateFromNow === '2 days ago') ? colors.AMBER : colors.RED)
      },
      fab: {
        list: [
          {
            color: colors.RED,
            status: 'Errores graves'
          },
          {
            color: colors.AMBER,
            status: 'Pocos errores'
          },
          {
            color: colors.GREEN,
            status: 'Correcto'
          }
        ],
        active: false,
        selectedIndex: 0
      },
      /**  @returns {Array<LogDetail>}  */
      logDetails: (distributor) => {
        return [
          /* <li>Ventas desactualizadas: {{ props.item.isMaxDateOutdated ? 'Sí' : 'No' }}</li>
          <li>Fecha supuesta de última venta: {{ props.item.maxDate.split(' ')[0] }}</li>
          <li>Tiempo supuesto desde última venta: {{ props.item.maxDateFromNow }}</li>
          <li>Registros desactualizados: {{ props.item.isRegisterDateOutdated ? 'Sí' : 'No' }}</li> */
          {
            visible: false,
            highlightable: false,
            label: 'Última fecha',
            data: (showAll) => `${distributor.salesLastUpdate || 'No se encontró'} (${distributor.salesLastUpdateFromNow || 'No se encontró'})`
          },
          {
            visible: true,
            highlightable: false,
            label: 'Problemas con el log',
            data: (showAll) => {
              let failedStatus = (distributor.isSalesMaxDateOutdated || distributor.isSalesLastUpdatedOutdated) && (distributor.salesMaxDateFromNow !== 'a day ago' && !distributor.salesLastUpdateFromNow !== 'a day ago')
              let reason = 'Log tiene un día o más de antiguedad'
              return failedStatus ? `Sí. ${reason}` : 'No'
            }
          },
          {
            visible: true,
            highlightable: false,
            label: 'Ventas actualizadas',
            data: (showAll) => `${!distributor.isSalesMaxDateOutdated ? 'Sí' : 'No'}`
          },
          {
            visible: true,
            highlightable: false,
            label: 'Fecha supuesta de última venta',
            data: (showAll) => `${distributor.salesMaxDate.split(' ')[0]}`
          },
          {
            visible: true,
            highlightable: false,
            label: 'Tiempo supuesto desde última venta',
            data: (showAll) => `${distributor.salesMaxDateFromNow}`
          },
          {
            visible: true,
            highlightable: false,
            label: 'Registros actualizados',
            data: (showAll) => `${!distributor.isSalesLastUpdatedOutdated ? 'Sí' : 'No'}`
          }
        ]
      }
    },
    {
      cardType: 'INCONSISTENCIES',
      enabled: true,
      iconPath: 'assets/dashboard-icons/card-database.png',
      info: (isLoading) => {
        const nonInconsistent = supervisorStorage.getNonInconsistencyCorrectData()
        const total = supervisorStorage.getSupervisorFtpFiles().length
        const inconsistent = total - nonInconsistent

        const percentageInconsistency = nonInconsistent / total

        if (isLoading) {
          return {
            lightColor: 'grey',
            cardNumber: 0,
            message: 'Verificando archivos'
          }
        }
        if (total === nonInconsistent) {
          return {
            lightColor: colors.GREEN,
            cardNumber: 0,
            message: 'Correcto, los datos relacionados están completos'
          }
        }
        if (percentageInconsistency > 0.9) {
          return {
            lightColor: colors.AMBER,
            cardNumber: inconsistent,
            message: `de ${total} distribuidora(s) tiene datos relacionados incompletos`
          }
        }
        return {
          lightColor: colors.RED,
          cardNumber: inconsistent,
          message: `de ${total} distribuidora(s) tiene datos relacionados incompletos`
        }
      },
      details: {
        title: `Título para 'Datos relacionados'`,
        message: '',
        body: {
          card: [
            {
              color: colors.GREEN,
              description: 'El 100% de distribuidoras tiene datos relacionados completos'
            },
            {
              color: colors.AMBER,
              description: 'Al menos 90% de distribuidoras tiene datos relacionados completos'
            },
            {
              color: colors.RED,
              description: 'Menos del 90% de distribuidoras tiene datos relaciones completos'
            }
          ],
          detail: [
            {
              color: colors.GREEN,
              description: 'Datos relacionados están completos'
            },
            {
              color: colors.AMBER,
              description: 'Datos relacionados faltantes'
            },
            {
              color: colors.LIGHT_RED,
              description: 'No se encontró información al respecto'
            }
          ]
        }
      },
      // Merge in indicator object which will be traspased to the visual object
      indicator: (item) => { // Same as the info key
        let baseColor = colors.LIGHT_RED

        return item.inconsistenciesCounter === -1 ? baseColor : (item.inconsistenciesCounter === 0 ? colors.GREEN : colors.AMBER)
      },
      fab: {
        list: [
          {
            color: colors.LIGHT_RED,
            status: 'Incompleto, no encontrado'
          },
          {
            color: colors.AMBER,
            status: 'Pocos errores'
          },
          {
            color: colors.GREEN,
            status: 'Correcto'
          }
        ],
        active: false,
        selectedIndex: 0
      },
      logDetails: (distributor) => {
        return [
          {
            visible: true,
            highlightable: false,
            label: 'Obtener archivo',
            data: (showAll) => {
              return (
                Vue.component('log-details', {
                  data () {
                    return {}
                  },
                  template: `
                    <span>
                      <v-btn
                        small icon
                        :style="[{'background-color':distributor.inconsistenciesFileUrl ? '#00B4C7' : '#FF3737'}, {'color':'white'}]"
                        @click="getInconsistencyFile"
                        :disabled="notInconsisteciesFound()"
                      >
                        <v-icon small>cloud_download</v-icon>
                      </v-btn>
                      <span v-if="notInconsisteciesFound()">No existen inconsistencias</span>
                    </span>
                  `,
                  methods: {
                    notInconsisteciesFound () {
                      return this.distributor.inconsistenciesCounter === 0
                    },
                    getInconsistencyFile () {
                      if (this.distributor.inconsistenciesFileUrl) {
                        eventBus.$emit('open-inconsistencies-report-question-dialog', {
                          downloadLink: this.distributor.inconsistenciesFileUrl,
                          distributorCode2: this.distributor.distributorCode2
                        })
                      } else {
                        eventBus.$emit('open-custom-snack-bar', {message: 'No existe link de descarga', itsOk: false})
                      }
                    }
                  },
                  props: {
                    showAll: {
                      type: Boolean,
                      default () {
                        return false
                      }
                    },
                    card: {
                      type: Object,
                      default () {
                        return {}
                      }
                    },
                    distributor: {
                      type: Object,
                      default () {
                        return {}
                      }
                    }
                  }
                })
              )
            }
          }
        ]
      }
    },
    {
      cardType: 'REPORTS GENERATOR',
      enabled: true,
      iconPath: 'assets/dashboard-icons/card-remote-files.png',
      info: (isLoading) => {
        return {
          lightColor: colors.RED,
          cardNumber: '99+',
          message: 'Errores y advertencias al generar reportes'
        }
      },
      details: {
        title: 'Título no definido',
        message: 'Mensaje no definido',
        body: {
          card: [
            {
              color: '',
              description: 'No definido'
            }
          ],
          detail: [
            {
              color: '',
              description: 'No definido'
            }
          ]
        }
      },
      indicator: (item) => {
        let baseColor = colors.LIGHT_GREY
        // let baseColor = colorIndicators.AMBER
        return baseColor
      },
      fab: {
        list: [
          {
            color: colors.LIGHT_GREY,
            status: 'Indefinido'
          }
        ],
        active: false,
        selectedIndex: 0
      },
      logDetails: (distributor) => {
        return [
          {
            visible: true,
            highlightable: false,
            label: 'No definido',
            data: (showAll) => 'No definido'
          }
        ]
      }
    },
    {
      cardType: 'SHIPPING CONTROL',
      enabled: true,
      iconPath: 'assets/dashboard-icons/card-remote-files.png',
      info: (isLoading) => {
        return {
          lightColor: colors.RED,
          cardNumber: '99+',
          message: 'No definido'
        }
      },
      details: {
        title: 'Título no definido',
        message: 'Mensaje no definido',
        body: {
          card: [
            {
              color: '',
              description: 'No definido'
            }
          ],
          detail: [
            {
              color: '',
              description: 'No definido'
            }
          ]
        }
      },
      indicator: (item) => {
        let baseColor = colors.LIGHT_GREY
        return baseColor
      },
      fab: {
        list: [
          {
            color: colors.LIGHT_GREY,
            status: 'Indefinido'
          }
        ],
        active: false,
        selectedIndex: 0
      },
      logDetails: (distributor) => {
        return [
          {
            visible: true,
            highlightable: false,
            label: 'No definido',
            data: (showAll) => 'No definido'
          }
        ]
      }
    }
  ]
}

export default {
  getCardsPointer () {
    return {
      requestFinished,
      cards
    }
  },
  getCards (options) {
    /*
      options: {
        onSuccess: () => {},
        onError: () => {}
      }
    */
    axios.get(uris.URL_SUPERVISOR_REMOTE_GET_CARDS)
      .then((response) => {
        let temp = []
        // console.log('CARDS OBTAINED', response)
        // temp.splice(0)
        temp.push(...response.data.rows)
        // AQUI SE INSERTARIA LA INFORMACION DESDE CARDSCOMPLEMENTARY
        temp.forEach((card) => {
          card.extra = omit(find(cardsComplementary(), (item) => item.cardType === card.cardType) || find(cardsComplementary(), (item) => item.cardType === 'DEFAULT'), 'cardType')
        })

        cards.splice(0)
        cards.push(...temp)
        if (options.onSuccess) {
          options.onSuccess(cards)
        }
        requestFinished = true
      }, (err) => {
        // console.warn('ERROR GETTING CARDS', err)
        if (options.onError) {
          options.onError(err)
        }
        requestFinished = true
      })
    return cards
  },
  updateCards (options) {
    /*
      options: {
        data: {
          cards: [
            {
              cardType: '',
      iconPath: 'assets/dashboard-icons/card-remote-files.png',
              cardName: '',
              enabled: false
            },
            ...
          ]
        },
        onSuccess: () => {},
        onError: () => {}
      }
     */
    axios.post(uris.URL_SUPERVISOR_REMOTE_UPDATE_CARDS, {
      cards: options.data.cards
    })
      .then((response) => {
        // console.log('CARDS UPDATED', response)
        // MAPEAR, REEMPLAZANDO LOS VIEJOS VALORES POR NUEVOS?
        map(cards, (row, index) => {
          assign(row, options.data.cards[index])
        })
        if (options.onSuccess) {
          options.onSuccess(response.data)
        }
      }, (err) => {
        console.warn('ERROR UPDATING CARDS', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/storage/cardsStorage.js